import { inject, Injectable } from "@angular/core";
import { Role } from "../interfaces/role.interface";
import { SecurityService } from "common";
import { SenderIdClaims } from "../constants";
import { BehaviorSubject, tap } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private securityService = inject(SecurityService);

  private _role$ = new BehaviorSubject<Role>(null);

  role$ = this._role$.asObservable();

  get role() {
    return this._role$.value;
  }

  get isAdmin() {
    return this.role === Role.Admin;
  }

  get isSido() {
    return this.role === Role.Sido;
  }

  get isPaOrMsp() {
    return this.role === Role.PaOrMsp;
  }

  get hasNoRole() {
    return !this.role;
  }

  constructor() {
    this.securityService.userEvents.pipe(
      tap(() => {
        const role = this.getRole();
        this._role$.next(role);
      })
    ).subscribe()
  }

  private getRole() {
    if (!this.securityService.isLoggedIn()) {
      return null;
    }
    const currentAccount = this.securityService.getSelectedAccount();
    const currentUserAssociatedAccounts = this.securityService.getClaim(SenderIdClaims.AssociatedAccount) as string[];
    const hasAdminClaim = this.securityService.hasClaim(SenderIdClaims.ComRegAdmin, 'true');
    const hasSidoClaim = currentUserAssociatedAccounts.indexOf(`${currentAccount.accountCode}|SIDO`) >= 0;
    const hasPaOrMspClaim = currentUserAssociatedAccounts.indexOf(`${currentAccount.accountCode}|PA`) >= 0;

    if (hasAdminClaim) {
      return Role.Admin;
    } else if (hasSidoClaim) {
      return Role.Sido;
    } else if (hasPaOrMspClaim) {
      return Role.PaOrMsp;
    }
  }
}
